var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ask-me-page"},[_c('div',{staticClass:"layout__header"},[_c('div',[_c('Title',{staticClass:"layout__title"},[_vm._v(_vm._s(_vm.pageTitle))])],1),_c('div',{staticClass:"layout__stats"},[_c('stats')],1)]),_c('div',{staticClass:"page"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }